// extracted by mini-css-extract-plugin
module.exports = {"pageName":"ViewSupplier_pageName__27esO","backButton":"ViewSupplier_backButton__1709K"};